import React, { Component } from "react";

class CommonDay extends Component {
  render() {
    const { dia, disponibilidad, dia_semana } = this.props;
    const estado = this.props.datos.fetchingState;

    return (
      <div className={this.getClassName(dia_semana)}>
        <span className="calendar-date">{dia}</span>
        {/* <br/><span className="calendar-event">{ estado ? 'L' : (disponibilidad)}</span> */}
        <br />
        {(disponibilidad == -1) || (disponibilidad == 0) ? (
          <span className="calendar-event-agotado">
            {estado ? "L" :  disponibilidad == 0 ? '0' : '-'}
          </span>
        ) : (
          <span className="calendar-event">
            {estado ? "L" : disponibilidad}
          </span>
        )}
      </div>
    );
  }

  getClassName(dia_semana) {
    if (dia_semana === 5 || dia_semana === 6) {
      return "calendar-day weekend";
    }
    return "calendar-day";
  }
}

export default CommonDay;
